import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import Select from 'component/Select/Select'
import ThemeSelectField from 'component/priceBanner/selects/ThemeSelectField'
import { isEmpty } from 'utils/validations'
import CloseIconSVG from 'component/svgComponents/close'
import moment from 'moment'

const SideFilterList = ({
  sideFilterVisible,
  submit,
  translate,
  closeFilters,
  user,
  initialFilters
}) => {
  const initialState = {
    idBranches: [],
    idBranchesCodes: [],
    status: null,
    theme: 'todos', 
    dtStart: null,
    dtEnd: null,
  }

  const [formData, setFormData] = useState(initialState)
  const [allBranches, setAllBranches] = useState([])
  const [branchSelectionInitialized, setBranchSelectionInitialized] = useState(false)
  const [, setPreviousFormData] = useState(initialState)
  const [dateResetKey, setDateResetKey] = useState(0)

  const getStatusOptions = () => ([
    { label: 'Todos', value: null },
    { label: 'Ativa', value: 0 },
    { label: 'Inativa', value: 1 },
    { label: 'Expirada', value: 2 },
  ])

 
  useEffect(() => {
    if (
      initialFilters &&
      sideFilterVisible &&
      allBranches.length > 0
    ) {
      const restoredTheme =
        initialFilters.themeCode &&
        initialFilters.themeCode !== 'todos'
          ? initialFilters.themeCode
          : 'todos'

      const branchIdsToRestore =
        initialFilters.idBranches ||
        initialFilters.idBranchesCodes ||
        []

      let selectedBranches = []

      if (branchIdsToRestore.length > 0) {
        selectedBranches = branchIdsToRestore.map(branchId => {
          let foundBranch =
            allBranches.find(
              branch =>
                branch.value === branchId ||
                branch.idBranch === branchId
            )

          if (!foundBranch) {
            foundBranch = {
              idBranches: [branchId],
              label: `Loja ${branchId}`,
              value: branchId,
              idBranch: branchId,
            }
          }

          return foundBranch
        })
      } else {
        selectedBranches = allBranches.filter(
          o => o.visible !== false
        )
      }

      const statusOptions = getStatusOptions()
      const selectedStatus =
        initialFilters.status !== null &&
        initialFilters.status !== undefined
          ? statusOptions.find(
              o => o.value === initialFilters.status
            )?.value
          : null

      const restoredData = {
        idBranches: selectedBranches,
        idBranchesCodes: branchIdsToRestore,
        status: selectedStatus,
        theme: restoredTheme,
        dtStart: initialFilters.dtStart || null,
        dtEnd: initialFilters.dtEnd || null,
      }

      setFormData(restoredData)
      setPreviousFormData(restoredData)
    }
  }, [initialFilters, sideFilterVisible, allBranches])

  
  useEffect(() => {
    if (
      sideFilterVisible &&
      !branchSelectionInitialized &&
      formData.idBranches.length === 0 &&
      allBranches.length > 0
    ) {
      const allVisibleOptions =
        allBranches.filter(o => o.visible !== false)

      handleFormChange('idBranches', allVisibleOptions)
      setBranchSelectionInitialized(true)
    }
  }, [sideFilterVisible, allBranches, formData.idBranches.length, branchSelectionInitialized])

  const handleDate = (dates) => {
    setFormData(prev => ({
      ...prev,
      dtStart: moment(dates[0]).format('YYYY-MM-DD'),
      dtEnd: moment(dates[1]).format('YYYY-MM-DD'),
    }))
  }

  const resetFilter = () => {
    const allVisibleBranches = allBranches.filter(
      branch => branch.visible !== false
    )

    const allVisibleBranchCodes = allVisibleBranches.flatMap(branch => {
      if (branch.idBranches) return branch.idBranches
      if (branch.value) return [branch.value]
      return []
    })

    const resetState = {
      ...initialState,
      idBranches: allVisibleBranches,
      idBranchesCodes: allVisibleBranchCodes,
    }

    setFormData(resetState)
    setPreviousFormData(resetState)
    setDateResetKey(prev => prev + 1)
    setBranchSelectionInitialized(true)
  }

  const hasAnyFilterApplied = () => {
    const hasBranches =
      formData.idBranches && formData.idBranches.length > 0

    const hasTheme =
      formData.theme && formData.theme !== 'todos'

    const hasStatus =
      formData.status !== null &&
      formData.status !== undefined

    const hasDateRange =
      formData.dtStart && formData.dtEnd

    return (
      hasBranches ||
      hasTheme ||
      hasStatus ||
      hasDateRange
    )
  }

  const submitValues = () => {
    const transformedData = {
      idBranches: formData.idBranchesCodes,
      ...(formData.status != null && {
        status: Number(formData.status),
      }),
      dtStart: formData.dtStart || null,
      dtEnd: formData.dtEnd || null,
    }

    if (formData.theme && formData.theme !== 'todos') {
      transformedData.themeCode = formData.theme
    }

    setPreviousFormData(formData)
    submit(transformedData)
    closeFilters()
  }

  const handleFormChange = (field, selectedValue) => {
    if (field === 'idBranches') {
      const branchCodes = selectedValue.flatMap(item => {
        if (item.idBranches) return item.idBranches
        if (item.value) return item.value
        return []
      })

      if (!branchSelectionInitialized) {
        setBranchSelectionInitialized(true)
      }

      setFormData(prev => ({
        ...prev,
        idBranches: selectedValue,
        idBranchesCodes: branchCodes,
      }))
    } else if (field === 'status') {
      setFormData(prev => ({
        ...prev,
        status: selectedValue ?? null,
      }))
    } else if (field === 'theme') {
      setFormData(prev => ({
        ...prev,
        theme: selectedValue?.value ?? 'todos',
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: selectedValue,
      }))
    }
  }

  return (
    <>
      <div
        style={{ display: sideFilterVisible ? 'shown' : 'none' }}
        className='bg-filter'
      />

      <div
        style={{ display: sideFilterVisible ? '' : 'none' }}
        className='right-filter-container-side-list'
      >
        <CloseIconSVG
          className='right-filter-svg'
          onClick={closeFilters}
        />

        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        <RegionBranchMultipleSelect
          required
          name='idBranches'
          label={translate('irc.store')}
          placeholder='Selecione uma ou mais lojas'
          user={user}
          translate={translate}
          onChange={(e) =>
            handleFormChange('idBranches', e.target.value)
          }
          value={formData.idBranches}
          getAllBranchs={setAllBranches}
        />

        <ThemeSelectField
          label={translate('newPriceBannerFragment.theme')}
          placeholder='Todos'
          user={user}
          translate={translate}
          onChange={(e) => handleFormChange('theme', e)}
          value={formData.theme}
          required
          fill
          showAllOption
        />

        <Select
          fill
          required
          label={translate('status')}
          placeholder='Todos'
          options={getStatusOptions()}
          onChange={(e) =>
            handleFormChange('status', e?.value ?? null)
          }
          value={getStatusOptions().find(
            o => o.value === formData.status
          )}
        />

        <NewDateIntervalInput
          key={`date-input-${dateResetKey}`}
          t={translate}
          user={false}
          reset={isEmpty(formData.dtStart)}
          label='Período'
          required
          initialValue={
            formData.dtStart && formData.dtEnd
              ? [moment(formData.dtStart), moment(formData.dtEnd)]
              : null
          }
          onChange={handleDate}
          maxLimitDay={false}
        />

        <div
          style={{ marginTop: 30 }}
          className='flex flex-row gap-filters'
        >
          <button
            className='btn btn-danger-outline full-w'
            onClick={resetFilter}
          >
            {translate('suggestions.cleanFilters')}
          </button>

          <button
            className='btn btn-primary full-w'
            disabled={!hasAnyFilterApplied()}
            onClick={submitValues}
          >
            {translate('commonReport.filter')}
          </button>
        </div>
      </div>
    </>
  )
}

SideFilterList.propTypes = {
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired,
  user: PropTypes.object,
  initialFilters: PropTypes.object,
}

export default SideFilterList
export { SideFilterList }